import { tinValidateOption } from '@/helpers';
import { ValidateOptions } from '@/shared/modules/form';
import { CalculateForm } from '@/types';

export const tinValidate: ValidateOptions<Partial<CalculateForm>> = {
    ltlPaymentTin: tinValidateOption,
    ftlPaymentTin: tinValidateOption,
};
